import React, { useMemo } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "src/pages/_layout";
import Profile from "src/pages/Profile";
import { useAuth } from "src/context/Auth/context";
import PageWithoutBusinessGroupAccess from "src/pages/PageWithoutBusinessGroupAccess";
import ForgotPasswordSubmit from "src/pages/ForgotPasswordSubmit";
import PageScheduleRestriction from "src/pages/PageScheduleRestriction";
import Calendar from "src/pages/Calendar";
import RemoveTFA from "src/pages/RemoveTFA";
import LoginMicrosoft from "src/pages/LoginMicrosoft";
import RoutePrivate from "./private";

import ForgotPassword from "../pages/ForgotPassword";
import Home from "../pages/Home";
import Login from "../pages/Login";
import UsersInvitePage from "../pages/Config/UsersInvite";
import MyBusinessGroup from "../pages/MyBusinessGroup";

import ConfigRoutes from "./config.routes";
import AnalysisRoutes from "./analysis.routes";
import ErrorRoutes from "./error.routes";
import RisksRoutes from "./risks.routes";
import AuditsRoutes from "./audits.routes";
import IndicatorsRoutes from "./indicators.routes";
import MeetingsRoutes from "./meetings.routes";

import StrategicPlanning from "./strategic.planning.routes";
import OriginOccurrences from "./occurrences.routes";
import ActionsRoutes from "./actions.routes";
import ProjectsRoutes from "./projects.routes";
import FinancialManagementRoutes from "./financial.management.routes";
import BusinessDiagnostics from "./business.diagnostics.routes";
import TrashRoutes from "./trash.routes";
import reportsRoutes from "./reports.routes";

const Routes: React.FC = () => {
	const { user, company, permissions, scheduleRestriction, superUser, administrator } = useAuth();

	const MemorizedRoutes = useMemo(() => 
		[
			ActionsRoutes,
			BusinessDiagnostics,
			StrategicPlanning,
			ConfigRoutes,
			AnalysisRoutes,
			RisksRoutes,
			AuditsRoutes,
			IndicatorsRoutes,
			MeetingsRoutes,
			OriginOccurrences,
			ProjectsRoutes,
			BusinessDiagnostics,
			FinancialManagementRoutes,
			TrashRoutes,
			reportsRoutes,	
			ErrorRoutes
		]
	, [permissions]);

	return(
		<BrowserRouter>
			<Layout>
				<Switch>
					<RoutePrivate path="/login" key="login" exact component={Login} onlyPublicAccess />
					<RoutePrivate path="/login/microsoft" key="loginMicrosoft" exact component={LoginMicrosoft} onlyPublicAccess />

					<RoutePrivate path="/forgot" key="forgot" exact component={ForgotPassword} onlyPublicAccess />
					<RoutePrivate path="/forgot/submit/:key" key="forgotSubmit" exact component={ForgotPasswordSubmit} onlyPublicAccess />

					<RoutePrivate path="/tfa/remove/:key" key="tfaRemove" exact component={RemoveTFA} onlyPublicAccess />

					<RoutePrivate path="/users/invite/:key" key="usersInvite" exact component={UsersInvitePage} />

					{user && !(company && company !== null) && <Route path ="/" key="pageWithoutBusinessGroupAccess" component={PageWithoutBusinessGroupAccess} />}

					<RoutePrivate path="/myprofile" key="myprofile" exact component={Profile} isPrivate checkPermission={false} />

					{user && scheduleRestriction && <Route path ="/" key="pageScheduleRestriction" component={PageScheduleRestriction} />}
            
					<RoutePrivate path="/" key="home" exact component={Home} isPrivate checkPermission={false} />
					<RoutePrivate path="/dashboard/:dashboardId" key="homeSelected" exact component={Home} isPrivate checkPermission={false} />
					<RoutePrivate path="/calendar" key="calendar" exact component={Calendar} isPrivate checkPermission={false} />

					<RoutePrivate path="/mybusinessgroup" key="mybusinessgroup" exact component={MyBusinessGroup} isPrivate checkPermission={!(administrator || superUser)} />

					{MemorizedRoutes}

				</Switch>
			</Layout>
		</BrowserRouter>
	);};

export default Routes;
